import styled from 'styled-components';

export const Div = styled.div`
  width: 22px;
  margin-left: auto;
  z-index: 1;

  span {
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    svg {
      width: 16px;
      height: 16px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    span {
      font-size: 12px !important;
    }
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;
